import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Kalkulator.css";

function Kalkulator() {
  const [inputs, setInputs] = useState({
    coldLF: "", coldRF: "", coldLR: "", coldRR: "",
    hotLF: "", hotRF: "", hotLR: "", hotRR: "",
    targetHot: "", rimTemp: "", ambientTemp: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const calculate = () => {
    const values = Object.fromEntries(
      Object.entries(inputs).map(([k, v]) => [k, parseFloat(v)])
    );

    if (Object.values(values).some((v, idx) => idx < 10 && (isNaN(v) || v <= 0))) {
      return { error: "Please fill all numeric fields" };
    }

    const { coldLF, coldRF, coldLR, coldRR, hotLF, hotRF, hotLR, hotRR, targetHot, rimTemp, ambientTemp } = values;

    const calcWheel = (cold, hot) => {
      const correction = cold + (targetHot - hot);
      const newCold = ((correction + 1) * (273 + ambientTemp)) / (273 + rimTemp) - 1;
      return { correction: correction.toFixed(2), newCold: newCold.toFixed(2) };
    };

    return {
      LF: calcWheel(coldLF, hotLF),
      RF: calcWheel(coldRF, hotRF),
      LR: calcWheel(coldLR, hotLR),
      RR: calcWheel(coldRR, hotRR),
    };
  };

  const results = calculate();

  return (
    <div className="kalkulator-page">
      <div className="kalkulator-container">
        <h2>Pressure Calculator (4 Wheels)</h2>

        <div className="filter-and-buttons">
          <button onClick={() => navigate("/form")} className="back-button">Back</button>
        </div>

        <form className="kalkulator-form">

          <h3>Cold Pressures</h3>
          <div className="field-pair">
            <label>Cold LF:<input type="number" step="0.01" name="coldLF" value={inputs.coldLF} onChange={handleChange} /></label>
            <label>Cold RF:<input type="number" step="0.01" name="coldRF" value={inputs.coldRF} onChange={handleChange} /></label>
          </div>
          <div className="field-pair">
            <label>Cold LR:<input type="number" step="0.01" name="coldLR" value={inputs.coldLR} onChange={handleChange} /></label>
            <label>Cold RR:<input type="number" step="0.01" name="coldRR" value={inputs.coldRR} onChange={handleChange} /></label>
          </div>

          <h3>Hot Pressures</h3>
          <div className="field-pair">
            <label>Hot LF:<input type="number" step="0.01" name="hotLF" value={inputs.hotLF} onChange={handleChange} /></label>
            <label>Hot RF:<input type="number" step="0.01" name="hotRF" value={inputs.hotRF} onChange={handleChange} /></label>
          </div>
          <div className="field-pair">
            <label>Hot LR:<input type="number" step="0.01" name="hotLR" value={inputs.hotLR} onChange={handleChange} /></label>
            <label>Hot RR:<input type="number" step="0.01" name="hotRR" value={inputs.hotRR} onChange={handleChange} /></label>
          </div>

          <h3>Conditions</h3>
          <div className="field-pair">
            <label>Target Hot:<input type="number" step="0.01" name="targetHot" value={inputs.targetHot} onChange={handleChange} /></label>
            <label>Rim Temp (°C):<input type="number" step="0.01" name="rimTemp" value={inputs.rimTemp} onChange={handleChange} /></label>
          </div>
          <div className="field-pair">
            <label>Ambient Temp (°C):<input type="number" step="0.01" name="ambientTemp" value={inputs.ambientTemp} onChange={handleChange} /></label>
            {/* Puste pole, aby zachować parzystość */}
            <div style={{ flex: 1 }}></div>
          </div>

        </form>

        <div className="kalkulator-results">
          {results.error ? (
            <p className="error">{results.error}</p>
          ) : (
            <>
              <h3>Results</h3>
              <table>
                <thead>
                  <tr>
                    <th>Wheel</th>
                    <th>Correction</th>
                    <th>New Cold</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>LF</td><td>{results.LF.correction}</td><td>{results.LF.newCold}</td></tr>
                  <tr><td>RF</td><td>{results.RF.correction}</td><td>{results.RF.newCold}</td></tr>
                  <tr><td>LR</td><td>{results.LR.correction}</td><td>{results.LR.newCold}</td></tr>
                  <tr><td>RR</td><td>{results.RR.correction}</td><td>{results.RR.newCold}</td></tr>
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Kalkulator;

